module.exports = __webpack_public_path__ + "static/media/addQuestions.f70e557b.png";